import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ArrowRight, Check, Menu } from "lucide-react";

function PublicHomepage() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <Helmet>
        <title>Welcome - DairyKhataBook</title>
      </Helmet>

      <div className="relative flex min-h-screen min-h-[100dvh] min-w-0 w-full max-w-full flex-col overflow-hidden bg-paper text-ink">
        <div className="pointer-events-none absolute inset-x-0 top-0 h-80 bg-gradient-to-b from-primary/[0.08] to-transparent" />

        <header className="z-10 mx-auto flex min-w-0 w-full max-w-lg items-center justify-between px-5 py-4">
          <div className="flex items-center gap-2.5">
            <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-white shadow-[0_5px_18px_rgba(20,35,58,0.08)]">
              <img src="/images/logo.png" alt="" className="h-9 w-9 object-contain" />
            </span>
            <span className="text-[16px] font-extrabold tracking-[-0.02em] text-ink">
              DairyKhataBook
            </span>
          </div>

          <div className="relative">
            <button
              type="button"
              onClick={() => setMenuOpen((open) => !open)}
              className="flex h-11 w-11 items-center justify-center rounded-2xl bg-white text-primary shadow-[0_5px_18px_rgba(20,35,58,0.08)] transition active:scale-95"
              aria-label="Open menu"
              aria-expanded={menuOpen}
            >
              <Menu className="h-5 w-5" />
            </button>

            {menuOpen && (
              <div className="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-2xl bg-white p-1.5 shadow-[0_16px_40px_rgba(20,35,58,0.16)] ring-1 ring-black/[0.05]">
                <ul className="flex flex-col text-[13px] font-semibold text-ink">
                  <li>
                    <button
                      type="button"
                      onClick={() => navigate("/Contact")}
                      className="w-full rounded-xl px-3 py-3 text-left hover:bg-paper"
                    >
                      Contact
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      onClick={() => navigate("/PrivacyPolicy")}
                      className="w-full rounded-xl px-3 py-3 text-left hover:bg-paper"
                    >
                      Privacy Policy
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </header>

        <main className="z-[1] mx-auto flex min-w-0 w-full max-w-lg flex-1 flex-col justify-center px-5 pb-6 pt-8">
          <span className="mb-4 inline-flex w-fit rounded-full bg-primary/10 px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-primary">
            Dairy records, simplified
          </span>

          <h1 className="max-w-md text-[38px] font-black leading-[1.08] tracking-[-0.045em] text-ink sm:text-[44px]">
            Run your dairy business with clarity.
          </h1>
          <p className="mt-4 max-w-md text-[15px] font-medium leading-7 text-muted">
            Keep milk entries, customer balances, and daily payments organized in one dependable place.
          </p>

          <div className="my-7 rounded-[26px] bg-white p-5 shadow-[0_16px_42px_rgba(20,35,58,0.09)] ring-1 ring-black/[0.035]">
            {["Fast daily entries", "Clear customer balances", "Secure account access"].map((feature) => (
              <div
                key={feature}
                className="flex items-center gap-3 border-b border-line py-3 first:pt-0 last:border-0 last:pb-0"
              >
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <Check className="h-4 w-4" strokeWidth={2.5} />
                </span>
                <span className="text-[13.5px] font-bold text-ink">{feature}</span>
              </div>
            ))}
          </div>

          <div className="flex w-full flex-col gap-3">
            <button
              type="button"
              onClick={() => navigate("/login")}
              className="app-primary-button flex w-full items-center justify-center gap-2 text-[15px]"
            >
              Sign in
              <ArrowRight className="h-4 w-4" />
            </button>
            <button
              type="button"
              onClick={() => navigate("/register")}
              className="min-h-[52px] w-full rounded-2xl bg-white px-5 text-[15px] font-bold text-ink shadow-[0_6px_20px_rgba(20,35,58,0.07)] ring-1 ring-line transition active:scale-[0.98]"
            >
              Create account
            </button>
          </div>
        </main>

        <footer className="z-[1] px-4 py-5 text-center text-[11px] font-medium text-muted">
          © {new Date().getFullYear()} DairyKhataBook. All rights reserved.
        </footer>
      </div>
    </>
  );
}

export default PublicHomepage;
